import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';
import { Box, Paper } from '@mui/material';
import { useVideoPreviewStyles } from './videoPreview.styles';
import { VideoPreviewProps } from './videoPreview.types';

const VideoPreview = ({ url }: VideoPreviewProps) => {
  const { classes } = useVideoPreviewStyles();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <video
        className={classes.video}
        src={url}
        width="100%"
        height="100%"
        autoPlay={false}
        muted
      />
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper className={classes.paper}>
          <PlayCircleFilled />
        </Paper>
      </Box>
    </Box>
  );
};

export default VideoPreview;
